import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["item", "input", "tab", "sortBtn", "sortMenu", "sortLabel", "gridView", "tableView", "gridBtn", "tableBtn"]

    connect() {
        this.currentStatus = "all"
        this.currentSort = "updated"
        this.currentView = "grid"
    }

    filterStatus(event) {
        const status = event.currentTarget.dataset.status
        this.currentStatus = status

        // Update tab styles
        this.tabTargets.forEach(tab => {
            if (tab.dataset.status === status) {
                tab.classList.add("text-purple-600", "border-purple-600")
                tab.classList.remove("text-gray-500", "border-transparent", "hover:text-gray-700")
            } else {
                tab.classList.remove("text-purple-600", "border-purple-600")
                tab.classList.add("text-gray-500", "border-transparent", "hover:text-gray-700")
            }
        })

        this._applyFilters()
    }

    search() {
        this._applyFilters()
    }

    sort(event) {
        this.currentSort = event.currentTarget.dataset.sort
        this.sortLabelTarget.textContent = event.currentTarget.textContent.trim()
        this.toggleSort()
        this._sortItems()
    }

    toggleSort() {
        this.sortMenuTarget.classList.toggle("hidden")
    }

    hideSort(event) {
        if (!this.sortBtnTarget.contains(event.target) && !this.sortMenuTarget.contains(event.target)) {
            this.sortMenuTarget.classList.add("hidden")
        }
    }

    showGrid() {
        this.currentView = "grid"
        this.gridViewTarget.classList.remove("hidden")
        this.tableViewTarget.classList.add("hidden")
        this.gridBtnTarget.classList.add("bg-white", "shadow-sm", "text-gray-700")
        this.gridBtnTarget.classList.remove("text-gray-400")
        this.tableBtnTarget.classList.remove("bg-white", "shadow-sm", "text-gray-700")
        this.tableBtnTarget.classList.add("text-gray-400")
    }

    showTable() {
        this.currentView = "table"
        this.gridViewTarget.classList.add("hidden")
        this.tableViewTarget.classList.remove("hidden")
        this.tableBtnTarget.classList.add("bg-white", "shadow-sm", "text-gray-700")
        this.tableBtnTarget.classList.remove("text-gray-400")
        this.gridBtnTarget.classList.remove("bg-white", "shadow-sm", "text-gray-700")
        this.gridBtnTarget.classList.add("text-gray-400")
    }

    _applyFilters() {
        const query = this.hasInputTarget ? this.inputTarget.value.toLowerCase() : ""

        this.itemTargets.forEach(item => {
            const text = item.textContent.toLowerCase()
            const status = item.dataset.statusFilter

            const matchesSearch = !query || text.includes(query)
            const matchesStatus = this.currentStatus === "all" || status === this.currentStatus

            if (matchesSearch && matchesStatus) {
                item.classList.remove("hidden")
            } else {
                item.classList.add("hidden")
            }
        })
    }

    _sortItems() {
        const grid = this.gridViewTarget.querySelector("[data-sort-container]")
        const table = this.tableViewTarget.querySelector("[data-sort-container]")

        if (grid) this._sortContainer(grid)
        if (table) this._sortContainer(table)
    }

    _sortContainer(container) {
        const items = Array.from(container.children).filter(el => el.dataset.sortName !== undefined)

        items.sort((a, b) => {
            if (this.currentSort === "name") {
                return (a.dataset.sortName || "").localeCompare(b.dataset.sortName || "")
            } else if (this.currentSort === "updated") {
                return (b.dataset.sortUpdated || "").localeCompare(a.dataset.sortUpdated || "")
            } else if (this.currentSort === "created") {
                return (b.dataset.sortCreated || "").localeCompare(a.dataset.sortCreated || "")
            }
            return 0
        })

        items.forEach(item => container.appendChild(item))
    }
}
